/** El store de tenant guarda el codigo/slug; el id real de la sesion vive en user.tenantId. */
export function isCurrentTenant(tenantId: string, sessionTenantId?: string | null, storeTenantId?: string | null): boolean {
  return tenantId === (sessionTenantId ?? storeTenantId);
}
